<template>
  <v-badge
      bordered
      bottom
      right
      overlap
      class="badged mr-4"
      color="error"
      :icon="icon"
  >
    <v-avatar size="40">
      <v-img :src="src"></v-img>
    </v-avatar>
  </v-badge>
</template>

<script>
export default {
  name: 'ImageBadged',
  props: {
    icon: {
      required: true,
      type: String
    },
    src: {
      required: true,
      type: String
    }
  }
}
</script>

<style lang="scss" scooped>
.badged .v-icon {
  color: white!important;
  font-size: 12px!important;
}
</style>
